import { Page } from '@/layouts/page'
import { Skeleton } from '@/shared/components/ui'

export const DetalhesEmpreendimentoPageSkeleton = () => {
  return (
    <div data-testid="detalhes-empreendimento-skeleton">
      <Page.Main>
        <Page.Header>
          <Page.Title>
            <Skeleton className="h-7 w-96" />
          </Page.Title>
        </Page.Header>
        <Page.Section className="space-y-12">
          <div className="space-y-4">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-48 w-full" />
          </div>
          <div className="space-y-4">
            <Skeleton className="h-6 w-24" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-5/6" />
            </div>
          </div>
          <div className="space-y-4">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-32 w-full" />
          </div>
          <div className="space-y-4">
            <Skeleton className="h-6 w-24" />
            <div className="grid gap-4 md:grid-cols-2">
              <Skeleton className="h-24 w-full" />
              <Skeleton className="h-24 w-full" />
            </div>
          </div>
        </Page.Section>
      </Page.Main>
    </div>
  )
}
